import { render, staticRenderFns } from "./CustomerHistory.vue?vue&type=template&id=71e5f1a4&scoped=true"
import script from "./CustomerHistory.vue?vue&type=script&lang=js"
export * from "./CustomerHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e5f1a4",
  null
  
)

export default component.exports